import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { IState } from '~/sharedInterfaces/IState';
import { getDefaultLabelName } from '~/services/DefaultLabelNameService';

const componentName = 'successMessage';

const SuccessMessage: FC = () => {
  const { locale } = useSelector((state: IState) => state.widgetContext);
  const { header, body } = getDefaultLabelName(locale, componentName);

  // const handleClick = () => {
  //   window.open(redirectUrl);
  // };

  return (
    <div className="qred-widget qred-success-message-container">
      <p className="qred-first">
        <span className="qred-first">{header}</span>
      </p>
      <p className="qred-second">
        <span className="qred-first">{body}</span>
      </p>
      {/* {redirectUrl && <input type="button" onClick={handleClick} value={buttonText} />} */}
    </div>
  );
};

export default SuccessMessage;
